<template>
    <div class="DiagnosticResume">
        <!-- Head -->
        <div class="DiagnosticResume__head">
            <div class="h2">
                Bonne nouvelle !
            </div>

            <p>
                Vous pouvez réduire votre facture d’énergie jusqu’à 50% et demander des aides pour le remplacement de vos équipements !
            </p>
        </div>

        <!-- Content -->
        <div class="DiagnosticResume__content">
            <div class="DiagnosticResume__content-title">
                <svg
                    v-svg
                    symbol="Calculator"
                    size="0 0 220 220"
                    role="presentation"
                    class="icon--inline"
                ></svg>

                <h3>Voici notre diagnostic de votre situation *</h3>
            </div>

            <div class="DiagnosticResume__data-container">
                <div class="DiagnosticResume__data">
                    <p>Déperdition en kW</p>
                    <div> {{ dwellingResumeDatas.heat_loss }} <span>kW</span></div>
                    <div class="per">par an</div>
                </div>

                <div class="DiagnosticResume__data">
                    <p>Estimation de votre conso</p>
                    <div> {{ addThousandSeparationToNumber(Math.round(dwellingResumeDatas.heating_consumption)) }} <span>kWh</span></div>
                    <div class="per">par an</div>
                </div>

                <div class="DiagnosticResume__data">
                    <p>Facture actuelle</p>
                    <div>{{ addThousandSeparationToNumber(Math.round(dwellingResumeDatas.energy_bill_amount)) }} <span>€</span></div>
                </div>
            </div>
        </div>

        <!-- Infos -->
        <DropdownInfos
            :headText="diagnosticInfos.head"
            :contentText="diagnosticInfos.content"
        />

        <ActionsButtons 
            btnPrimaryLabel="Trouvez maintenant votre solution de chauffage"
            @primaryBtn::action="goNextPage"
            @secondBtn::action="goPrevPage"
        />
    </div>
</template>

<script>
import ActionsButtons from '@/includes/Simulator/ActionsComponents/ActionsButtons.vue';
import DropdownInfos from '@/components/DropdownInfos/DropdownInfos.vue'

import { addThousandSeparationToNumber } from "@/services/tools.js";
import EventBus from "@/event-bus";
import { mapActions } from "vuex";

export default {
    name: "DiagnosticResume",

    components: {
        ActionsButtons,
        DropdownInfos
    },


    props: {
        dwellingResumeDatas: {
            type: Object,
            default: {}
        }
    },

    data() {
        return {
            showDiagnosticInfos : false,
            diagnosticInfos: {
                head:`Cet outil permet d'estimer simplement la puissance de chauffage, les consommations énergétiques et les économies d'énergies liées à l'installation 
                    d'une nouvelle solution de chauffage.`,
                content:`Ces résultats sont une première approche sur la base d'hypothèses générales 
                n'engageant en aucune façon Proxiserve. Les calculs sont effectués sur la base des tarifs réglementés du gaz et de l'électricité 
                en vigueur au 1er janvier ${this.getCurrentYear()} ainsi que le tarif moyen du fioul domestique en ${this.getCurrentYear() - 1} publié sur le site de l'INSEE et des autres énergies 
                suivant des sources tarifaires indépendantes. Les calculs se basent sur les rendements suivants: SCOP PAC Air/Eau: 3,45. SCOP PAC Air/Air: 4,6. 
                Rendement chaudière classique: 90% sur PCI et Rendement chaudière à condensation 90% sur PCS. La rigueur climatique de l'année 2022 est considérée 
                pour les calculs de consommation.`
            }
        };
    },

    methods: {
        goNextPage() {
            this.$emit('diagnosticResume::goNextPage');
            EventBus.$emit('gtm-solution::push');
        },

        goPrevPage() {
            EventBus.$emit('tunnel-leadForm::display');
        },

        toggleInfosDetails() {
            this.showDiagnosticInfos = !this.showDiagnosticInfos
        },

        getCurrentYear() {
            return new Date().getFullYear();
        },

        /**
         * Map Actions
         */
        ...mapActions([
            "setCurrentStep"
        ]),

        //Imported functions
        addThousandSeparationToNumber
    },

    mounted() {
        EventBus.$emit('gtm-savings::push');
        this.setCurrentStep('save_energy');
    }
    
 
}
</script>

<style lang="scss">
    .DiagnosticResume { 
        margin-bottom: 100px;
        
        &__head {
            margin: 60px 0;
            padding: 0 10px;

            .h2 {
                font-size: 2.2rem;
                font-weight: $fw-robotoMB;
                color: $c-mcp-green;
                line-height: 1;
                margin-bottom: 20px;
            }

            p {
                font-size: 1.6rem;
            }
        }

        &__info {
            padding: 10px 20px;
            color: $c-blue-simu;
            background-color: rgba(86, 148, 242, .15);
            border-radius: 10px;

            @include breakpoint(only-md) {
                margin-bottom: 100px;
            }

            .info-head {
                cursor: pointer;
                display: flex;
                align-items: center;
                margin: 5px 0;

                p {
                    flex: 1;
                    margin-left: 10px;
                    text-decoration: underline;
                }

                .dropdown-arrow {
                    stroke: $c-blue-simu;

                    &.rotated {
                        transform: rotate(180deg);
                    }
                }
            }

            .info-content {
                margin: 0 20px;
            }
        }

        &__content {
            margin-bottom: 35px;
            padding: 15px;
            border: 2px solid $c-grey-5;
            border-radius: 10px;
            color: $c-grey-dark;

        }
        
        &__content-title {
            display: flex;
            justify-content: space-around;
            align-items: center;
            
            @include breakpoint(only-lg) {
                flex-direction: row-reverse;

                svg,
                h3 {
                    width: 50%;
                    margin-top: -75px;
                }
            }
        }

        &__data-container {
            display: flex;
            

            @include breakpoint(only-lg) {
                flex-wrap: wrap;

                .DiagnosticResume__data:nth-child(2) {
                    order: -1;
                    width: 100%;
                    padding-bottom: 20px;
                    border-bottom: 1px solid $c-grey-5;
                }

                .DiagnosticResume__data:nth-child(1) {
                    border-right: 1px solid $c-grey-5;
                }

                .DiagnosticResume__data:nth-child(1),
                .DiagnosticResume__data:nth-child(3) {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    width: 50%;
                    padding: 20px 10px 10px 10px;
                }
            }

            
        }
        
        &__data {
            text-align: center;

            p {
                font-size: 1.6rem;
                color: $c-grey-3;
            }

            div {
                font-size: 4rem;

                span {
                    font-size: 2rem;
                }
            }

            .per {
                display: none;
            }
        }
    }

    .DiagnosticResume {
        margin-bottom: 0;

        // Tablet 768px
        @include breakpoint(md) {
            &__head {
                display: flex;
                align-items: center;
                gap: 5vw;
                margin: 100px 0;
                padding: 0 0;

                .h2 {
                    max-width: 260px;
                    font-size: 6rem;
                    margin-bottom: 0px;
                }

                p {
                    font-size: 2.8rem;
                    line-height: 36px;
                    max-width: 45%;
                }
            }
        }

        // Tablet 1024px
        @include breakpoint(lg) {
            &__content {
                display: flex;
                gap: 20px;
                align-items: center;
                padding: 30px 5vw 0 0;
            }

            &__content-title {
                svg,
                h3 {
                    width: auto;
                    margin-top: 0;
                }

                svg {
                    margin-left: -30px;
                    margin-bottom: -11px;
                    max-width: none;
                }

                h3 {
                    max-width: 140px;
                    line-height: 35px;
                    font-size: 3rem; 
                }
            }

            &__data-container {
                flex: 2;

            }

            &__data {
                flex: 1;
                height: 160px;

                div {
                    font-size: 5rem;
                }

                .per {
                    display: block;
                    font-size: 2rem;
                }
            }
        }

        @include breakpoint(xl){
            &__data  {
                div {
                    font-size: 6rem;
                }
            }
        }
    }

    //Actions btn 
    .DiagnosticResume .right-content__cta-container {
        @include breakpoint(only-sm) {
            .btn-primary_chevron {
                padding: 15px 25px;
                max-width: 80%;
                font-size: 1.2rem;
            }
        }
    }
</style>